import { ModelVersion } from 'src/contexts/FilterContext/useModelVersions';
import { dayjs } from 'src/libs/dayjs';

/**
 * Removes the trailing " (Full)" suffix from a model name/alias for display.
 * The "(Quick)" suffix is intentionally kept — it marks quick-run preview
 * models, whereas "(Full)" is redundant noise.
 */
export const stripFullModelSuffix = (name: string): string =>
  name.replace(/\s*\(Full\)$/, '');

export const getModelMaxStartAndEndDatePickerDates = (
  currentModelVersion: ModelVersion | null,
) => {
  const datePickerMinDate = currentModelVersion?.dataStartDate
    ? dayjs(currentModelVersion.dataStartDate).toDate()
    : undefined;

  const datePickerMaxDate = currentModelVersion?.dataEndDate
    ? dayjs(currentModelVersion.dataEndDate).toDate()
    : undefined;

  return {
    datePickerMaxDate,
    datePickerMinDate,
  };
};
